// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import useAreProductsLoading from "@store/Framework/Common/Hooks/useAreProductsLoading";
import { useBunzlDispatch } from "@store/Framework/Store/Bunzl/BunzlReducer";
import SearchBox, { SearchBoxStyles } from "@store/Library/Components/Bunzl/Common/SearchBox";

import React from "react";
import { css } from "styled-components";

interface BulkListSearchListStyles {
    extendedStyles: SearchBoxStyles;
}
const bulkListSearchListStyles: BulkListSearchListStyles = {
    extendedStyles: {
        textField: {
            cssOverrides: {
                formInputWrapper: css`
                    z-index: 1;
                `,
            },
        },
    },
};
const BulkListSearchLists = () => {
    const bunzlDispatch = useBunzlDispatch();

    const handleSearch = (searchText: string) => {
        bunzlDispatch({ type: "Store/Pages/bulkLists/setInnerSearchText", innerSearchText: searchText });
    };
    const isLoading = useAreProductsLoading();
    return (
        <LoadingOverlay loading={isLoading}>
            <SearchBox
                extendedStyles={bulkListSearchListStyles.extendedStyles}
                onSearch={handleSearch}
                title={translate("Search Lists")}
                placeholder={translate("Search Lists by Name or Description")}
            />
        </LoadingOverlay>
    );
};

const widgetModule: WidgetModule = {
    component: BulkListSearchLists,
    definition: {
        group: "Common",
        icon: "Search",
    },
};

export default widgetModule;
